"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPalette(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 32 32', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm31.2851 5.3801c-4.2704-5.8334-14.4101-5.6926-22.4329-.0686-8.2031 5.7504-11.0732 15.3575-6.9262 21.3744 4.1365 6.0016 14.199 5.4391 22.4345.0667 4.383-2.8592 4.8141-4.4653 4.5211-6.0613-.3551-1.9427-2.2223-1.9674-2.6162-4.6087-.4502-3.0031 1.6635-3.599 4.2723-5.7377a3.62894 3.62894 0 0 0 .7474-4.9648zm-24.2851 20.6199a2.78449 2.78449 0 0 1 -3-2.5 2.78449 2.78449 0 0 1 3-2.5 2.78443 2.78443 0 0 1 3 2.5 2.78443 2.78443 0 0 1 -3 2.5zm0-8a2.78449 2.78449 0 0 1 -3-2.5 2.78449 2.78449 0 0 1 3-2.5 2.78443 2.78443 0 0 1 3 2.5 2.78443 2.78443 0 0 1 -3 2.5zm6-5.9922a2.78578 2.78578 0 0 1 -3-2.5039 2.78578 2.78578 0 0 1 3-2.5039 2.78578 2.78578 0 0 1 3 2.5039 2.78578 2.78578 0 0 1 -3 2.5039zm5-5.5078a2.78526 2.78526 0 0 1 3.0013-2.5 2.78526 2.78526 0 0 1 3.0013 2.5 2.78526 2.78526 0 0 1 -3.0013 2.5 2.78526 2.78526 0 0 1 -3.0013-2.5zm4.0172 17.5a2.78526 2.78526 0 0 1 -3.0013-2.5 2.78532 2.78532 0 0 1 3.0013-2.5 2.78526 2.78526 0 0 1 3.0013 2.5 2.78526 2.78526 0 0 1 -3.0013 2.5z' })));
}
exports.default = SvgPalette;
